import {React} from 'common'
import {Controller} from 'react-hook-form'
import {FormErrorText} from 'components/Control/Form'
import Input from '../Input'
import {Texts} from 'appearance'
import {useI18n} from 'store/Store'
import {styled} from '@mui/material'

const FormTextInput = ({
    name,
    label,
    control,
    errors,
    rules,
    required,
    disabled,
    width,
    height,
    fullWidth,
    type,
    initialValue = '',
    inputref,
    inputProps,
    InputProps,
    variant,
    LabelComponent,
    placeholder,
    optional,
    ...p
}) => {
    const {i18n} = useI18n()
    return (
        <Container {...p}>
            {LabelComponent ? (
                <LabelComponent />
            ) : (
                <LabelWrapper>
                    <Label>{label}</Label>
                    {optional && <Optional>{i18n.t('form.optional')}</Optional>}
                </LabelWrapper>
            )}
            <Controller
                name={name}
                control={control}
                rules={rules || {required}}
                render={({field: {onChange, value}}) => (
                    <Input
                        variant={variant}
                        onChange={onChange}
                        value={value || initialValue}
                        fullWidth={fullWidth}
                        required={required}
                        disabled={disabled}
                        type={type}
                        width={width}
                        height={height}
                        inputRef={inputref}
                        inputProps={inputProps}
                        InputProps={InputProps}
                        placeholder={placeholder}
                    />
                )}
            />
            {errors?.[name] && (
                <FormErrorText>
                    {errors[name].message || `valid ${label} is required`}
                </FormErrorText>
            )}
        </Container>
    )
}

export default FormTextInput

const Container = styled('div')`
    width: 100%;
`

const LabelWrapper = styled('div')`
    display: flex;
    align-items: center;
    flex: 1;
    gap: 6px;
`

const Label = styled(Texts.BoldText)`
    font-size: 18px;
`

const Optional = styled(Texts.RegularText)`
    font-size: 14px;
`
